import { EntityTable } from '@/features/admin/EntityTable';

export function ItensPage() {
  return (
    <EntityTable
      title="Inventário de Itens"
      subtitle="Instâncias físicas individuais (cada peça tem barcode/serial único)"
      endpoint="/v1/items"
      queryKey="items"
      itemLabel={(r: any) => r.serial || r.barcode || r.id}
      columns={[
        { key: 'barcode', label: 'Barcode', className: 'font-mono text-xs' },
        { key: 'serial', label: 'Serial', className: 'font-mono text-xs' },
        { key: 'model_name', label: 'Modelo' },
        { key: 'status', label: 'Status' },
        { key: 'phase', label: 'Fase atual' },
        {
          key: 'cycles', label: 'Ciclos',
          render: (r: any) => `${r.cycles_count ?? 0}${r.max_cycles ? ` / ${r.max_cycles}` : ''}`,
          className: 'text-right tabular-nums text-xs',
        },
      ]}
      fields={[
        { name: 'model_id', label: 'Modelo', type: 'entity', required: true, hideOnEdit: true, endpoint: '/v1/item-models', displayField: 'name', secondaryField: 'sku', hint: 'cadastre novos modelos na tela Modelos de Item' },
        { name: 'barcode', label: 'Barcode (DataMatrix gravado a laser)', type: 'text', required: true, hideOnEdit: true },
        { name: 'serial', label: 'Serial fabricante', type: 'text' },
        { name: 'acquired_at', label: 'Data de aquisição', type: 'date' },
        { name: 'is_third_party', label: 'Consignado / OPME', type: 'checkbox' },
        { name: 'supplier_id', label: 'Fornecedor', type: 'entity', endpoint: '/v1/suppliers', displayField: 'name', secondaryField: 'cnpj', visible: (f) => !!f.is_third_party },
      ]}
    />
  );
}
